export const POLL_DATA_TYPE = 'poll'
